// extracted by mini-css-extract-plugin
export default {"tasks":"sL-z","task":"tL-z","svg":"uL-z","text":"vL-z"};